import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { useController } from 'react-hook-form';
import { get } from 'lodash';
import { DonorSolidIcon, ServiceIcon } from 'components/icons';
import styles from './GainSettingsProps.module.css';

const Context = createContext({});

function GainSettingsProps({ props, children }) {
  return <Context.Provider value={props}>{children}</Context.Provider>;
}

GainSettingsProps.Id = function GainSettingsTablePropsId({ networkElement }) {
  const props = useContext(Context);

  return (
    <span className={styles.id}>
      {networkElement === 'DU' ? <DonorSolidIcon className={styles.icon} /> : <ServiceIcon className={styles.icon} />}
      {get(props, `${networkElement}.inventory-info.serial-id`)}
    </span>
  );
};

GainSettingsProps.Title = function GainSettingsTablePropsValue({ children }) {
  return <span className={styles.title}>{children}</span>;
};

GainSettingsProps.Value = function GainSettingsTablePropsValue({ name, ...rest }) {
  const props = useContext(Context);

  return (
    <span className={styles.value} {...rest}>
      {get(props, name, 'N/A')}
    </span>
  );
};

GainSettingsProps.Input = function GainSettingsTablePropsInput({ name, ...rest }) {
  const {
    field: { value: initialValue, onChange, onBlur },
    fieldState: { isDirty, error }
  } = useController({
    name,
    rules: {
      validate: {
        integer: (value) => value == null || Number.isInteger(value) || 'Must be integer'
      }
    }
  });
  const isValid = !error;
  const [value, setValue] = useState(initialValue != null ? initialValue.toString(10) : '');
  const handleChange = useCallback(
    (event) => {
      const nextValue = event.target.value;
      onChange(nextValue.length > 0 ? Number.parseFloat(nextValue) : undefined);
      setValue(nextValue);
    },
    [onChange]
  );
  useEffect(() => {
    if (!isDirty) {
      setValue(initialValue != null ? initialValue.toString(10) : '');
    }
  }, [isDirty, initialValue]);

  return (
    <input
      type="number"
      aria-invalid={!isValid}
      name={name}
      value={value}
      autoComplete="off"
      className={classNames(styles.input, { [styles.invalid]: !isValid })}
      onBlur={onBlur}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default GainSettingsProps;
